import type React from "react";
import { cn } from "@workspace/ui/lib/utils";

interface FormattedPriceProps {
	price?: number;
	currency?: string;
	className?: string;
	variant?: "price" | "discount";
}

export const FormattedPrice: React.FC<FormattedPriceProps> = ({
	price,
	currency = "NOK",
	className,
	variant = "price",
}) => {
	const formatter = (amount: number) =>
		new Intl.NumberFormat("no-NO", {
			style: "currency",
			currency: currency,
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		}).format(amount);

	if (!price) {
		return null;
	}

	if (variant === "price") {
		return <span className={cn(className)}>{formatter(price)}</span>;
	}

	if (variant === "discount") {
		return (
			<span className={cn(className, "line-through")}>{formatter(price)}</span>
		);
	}
};
